export default __webpack_public_path__ + "static/media/home.be1894d2.svg";